let _hasViewEverBeenBackgrounded = document.hidden;

type ViewBackgroundedListener = () => void;
const backgroundedListeners = new Set<ViewBackgroundedListener>();

/**
 * Registers a listener invoked when the current view first becomes backgrounded
 * (the false → true transition of `hasViewEverBeenBackgrounded`, re-armed by
 * `resetViewBackgrounded` on each new view).
 *
 * @returns An unsubscribe function
 */
export function onViewBackgrounded(
  listener: ViewBackgroundedListener
): () => void {
  backgroundedListeners.add(listener);
  return () => {
    backgroundedListeners.delete(listener);
  };
}

export function hasViewEverBeenBackgrounded() {
  return _hasViewEverBeenBackgrounded;
}

export function resetViewBackgrounded() {
  _hasViewEverBeenBackgrounded = document.hidden;
}

export function setViewBackgrounded() {
  if (_hasViewEverBeenBackgrounded) {
    return;
  }
  _hasViewEverBeenBackgrounded = true;
  backgroundedListeners.forEach(listener => listener());
}

function handleVisibilityChange() {
  if (document.hidden) {
    setViewBackgrounded();
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', handleVisibilityChange);
}
